import React from 'react';
import './css/WhatsAppButton.css'; // Import corresponding CSS
import useAnalyticsEventTracker from './useAnalyticsEventTracker';

function WhatsAppButton() {
  const gaEventTracker = useAnalyticsEventTracker('Contact');

  return (
    <a
      href="https://api.whatsapp.com/send?phone=919755565810&text=Hello%20Murtaza"
      target="_blank"
      rel="noopener noreferrer"
      className="contact-button whatsapp-button"
      title="WhatsApp Murtaza"
      aria-label="WhatsApp Murtaza"
      onClick={() => gaEventTracker('click', 'Whatsapp Button', 'Whatsapp')}
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  );
}

export default WhatsAppButton;
